'use es6';

import { createSelector } from 'reselect';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import { getIsPublic } from './auth';
import { getMinimumRequiredPlan } from '../utils/compatibility';
export const getFeatureCompatibility = state => state.details.get('compatibility');
export const makeGetRequiredPlansForFeatures = () => createSelector([getFeatureCompatibility, (_, integrationFeatures) => integrationFeatures], ({
  compatibility,
  portalTiers
}, integrationFeatures) => {
  if (!compatibility || compatibility.isEmpty() || !integrationFeatures) {
    return null;
  }

  return integrationFeatures.map(integrationFeature => getMinimumRequiredPlan(integrationFeature, compatibility, portalTiers));
});

const getSlugFromProps = (_, props) => props.slug;

const getListingViewsCache = state => state.details.get('listingViewsCache');

const getListingViewsFetchErrorCache = state => state.details.get('listingViewsFetchErrorCache');

const getListingViewsFetchStatusCache = state => state.details.get('listingViewsFetchStatusCache');

const getReviewabilityFetchStatusCache = state => state.details.get('reviewabilityFetchStatusCache');

export const makeGetListingViewFetchError = () => createSelector([getSlugFromProps, getListingViewsFetchErrorCache], (slug, listingViewsFetchErrorCache) => listingViewsFetchErrorCache.get(slug));
export const makeGetListingViewFetchStatus = () => createSelector([getSlugFromProps, getListingViewsFetchStatusCache], (slug, listingViewsFetchStatusCache) => listingViewsFetchStatusCache.get(slug, RequestState.UNINITIALIZED));
export const makeGetListingView = () => createSelector([getSlugFromProps, getListingViewsCache], (slug, listingViewsCache) => listingViewsCache.get(slug));
export const makeGetReviewabilityFetchStatus = () => createSelector([getSlugFromProps, getReviewabilityFetchStatusCache, getIsPublic], (slug, reviewabilityFetchStatusCache, isPublic) => isPublic ? RequestState.SUCCEEDED : reviewabilityFetchStatusCache.get(slug, RequestState.UNINITIALIZED));
export const getListingViewReferrer = state => state.details.get('referrer');